
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

export function FormatRequirements() {
  return (
    <Alert>
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        <strong>CSV Format Requirements:</strong><br />
        Your CSV must have these exact headers (case-sensitive):<br />
        <code>flight_number,organization_code,departure_city_code,arrival_city_code,aircraft_type_code,scheduled_departure,scheduled_arrival,status,status_reason,gate</code><br />
        <br />
        <strong>Notes:</strong><br />
        • Use organization/city/aircraft codes instead of UUIDs (e.g., "AA", "NYC", "B737")<br />
        • Use ISO datetime format for scheduled_departure and scheduled_arrival (YYYY-MM-DDTHH:mm:ss)<br />
        • Status must be: "On Time", "Delayed", or "Cancelled"<br />
        • status_reason and gate can be empty<br />
        • All other fields are required<br />
      </AlertDescription>
    </Alert>
  );
}
